export const ged_traduction = [
  // English
  {
    id: 0,
    GED_HEADER_MAIN_TITLE: "Document management",
    GED_DIRECTORIES_SCROLLER_TITLE: "Quick access",
    GED_ADD_DIRECTORY: "Add a folder",
    GED_ADD_FILE: "Add a file",
    GED_DIRECTORY_ITEM_DOCUMENT_1: "documents",
    GED_DIRECTORY_ITEM_DOCUMENT_2: "No document",
    GED_MODAL_FILE_MAIN_TITLE: "Detailed sheet",
    GED_MODAL_ADD_FILE_MAIN_TITLE: "Add a file",
    GED_MODAL_DIRECTORY_MAIN_TITLE: "Folder sheet",
    GED_MODAL_ADD_DIRECTORY_MAIN_TITLE: "Add a folder",
    GED_DROPDOWN_ITEM_1: "Modify",
    GED_DROPDOWN_ITEM_2: "Delete",
    GED_DIRECTORY_PATH_LABEL: "Folder:",
    GED_DIRECTORY_CREATED_DATE_LABEL: "Created date:",
    GED_DIRECTORY_UPDATED_DATE_LABEL: "Date last modified:",
    GED_CONFIRMATION_DELETE_MESSAGE: "Are you sure you want to delete this folder ?",
    GED_CONFIRMATION_DELETE_FILE_MESSAGE: "Are you sure you want to delete this file ?",
    GED_SUCCESS_DELETE_FOLDER: "The folder has been deleted successfully.",
    GED_SUCCESS_DELETE_FILE: "The file has been deleted successfully.",
    GED_ERROR_DELETE_FOLDER: "Error deleting the folder.",
    GED_ERROR_DELETE_FILE: "Error deleting the file.",
    GED_ERROR_GET_REFERENTIALS: "An error occurred while loading the document management.",
    GED_SORT_LABEL_1: "Sort by name",
    GED_SORT_LABEL_2: "Sort by date",
    GED_SEARCH_RESULTS: "Search results for :",
    GED_ICON_CLEAR_SEARCH: "Clear search",
    GED_ICON_RETOUR_ACCUEIL: "Back to home",
    GED_EMPTY: "No documents",
    // Permissions
    GED_PERMISSIONS_EDIT_FILE: "You do not have permission to modify this file.",
    GED_PERMISSIONS_DELETE_FILE: "You do not have permission to delete this file.",
    GED_PERMISSIONS_EDIT_FOLDER: "You do not have permission to modify this folder.",
    GED_PERMISSIONS_DELETE_FOLDER: "You do not have permission to delete this folder.",
  },
  // Français
  {
    id: 1,
    GED_HEADER_MAIN_TITLE: "Gestion documentaire",
    GED_DIRECTORIES_SCROLLER_TITLE: "Accès rapide",
    GED_ADD_DIRECTORY: "Ajouter un dossier",
    GED_ADD_FILE: "Ajouter un fichier",
    GED_DIRECTORY_ITEM_DOCUMENT_1: "documents",
    GED_DIRECTORY_ITEM_DOCUMENT_2: "Aucun document",
    GED_MODAL_FILE_MAIN_TITLE: "Fiche détaillée",
    GED_MODAL_ADD_FILE_MAIN_TITLE: "Ajouter un fichier",
    GED_MODAL_DIRECTORY_MAIN_TITLE: "Fiche du dossier",
    GED_MODAL_ADD_DIRECTORY_MAIN_TITLE: "Ajouter un dossier",
    GED_DROPDOWN_ITEM_1: "Modifier",
    GED_DROPDOWN_ITEM_2: "Supprimer",
    GED_DIRECTORY_PATH_LABEL: "Dossier:",
    GED_DIRECTORY_CREATED_DATE_LABEL: "Date de création:",
    GED_DIRECTORY_UPDATED_DATE_LABEL: "Date de dernière modification:",
    GED_CONFIRMATION_DELETE_MESSAGE: "Êtes-vous sûr de vouloir supprimer ce dossier ?",
    GED_CONFIRMATION_DELETE_FILE_MESSAGE: "Êtes-vous sûr de vouloir supprimer ce fichier ?",
    GED_SUCCESS_DELETE_FOLDER: "Le dossier à été supprimé avec succès.",
    GED_SUCCESS_DELETE_FILE: "Le fichier à été supprimé avec succès.",
    GED_ERROR_DELETE_FOLDER: "Erreur lors de la suppression du dossier.",
    GED_ERROR_DELETE_FILE: "Erreur lors de la suppression du fichier.",
    GED_ERROR_GET_REFERENTIALS:
      "Une erreur est survenue lors du chargement de la gestion documentaire.",
    GED_SORT_LABEL_1: "Trier par nom",
    GED_SORT_LABEL_2: "Trier par date",
    GED_SEARCH_RESULTS: "Résultats pour :",
    GED_ICON_CLEAR_SEARCH: "Effacer la recherche",
    GED_ICON_RETOUR_ACCUEIL: "Retour à l'accueil",
    GED_EMPTY: "Aucun document",
    // Permissions
    GED_PERMISSIONS_EDIT_FILE: "Vous n'avez pas la permission de modifier ce fichier.",
    GED_PERMISSIONS_DELETE_FILE: "Vous n'avez pas la permission de supprimer ce fichier.",
    GED_PERMISSIONS_EDIT_FOLDER: "Vous n'avez pas la permission de modifier ce dossier.",
    GED_PERMISSIONS_DELETE_FOLDER: "Vous n'avez pas la permission de supprimer ce dossier.",
  },
]
